import { shimmer, toBase64 } from "@src/utils/shimmer";
import Image from "next/image";
import React from "react";
import flower from "../../../../public/images/pinkFlowerImage.png";
import { EventBySlugQuery } from "@src/@types/api.d";
import Icon from "@src/components/Icon";

interface IFooter {
  slug: EventBySlugQuery | undefined;
}

const Footer = ({ slug }: IFooter) => {
  return (
    <footer className="w-full min-h-[30rem] overflow-hidden bg-[linear-gradient(180deg,_#00234B_0%,_#002D60_100%)] flex flex-col">
      <div className="h-[15rem] flex flex-col gap-2 justify-center items-center relative px-8 overflow-hidden">
        <div className="text-[#FCE2B0]">
          <Icon iconName="ring2" />
        </div>

        <p className="font-ntFab text-[1rem] md:text-[1.5rem] leading-[100%] mt-[2rem] font-normal tracking-[0.2rem] text-[#FCE2B0]">
          MADE WITH{" "}
          <a
            href="https://www.inawo.com"
            target="_blank"
            rel="noopener noreferrer"
            className="border-b-[0.5px] border-[#FCE2B0] pb-[0.5px]"
          >
            INAWO
          </a>
        </p>

        <p className="font-ebGaramond text-[1rem] md:text-[1.5rem] leading-[100%] mt-[0.5rem] w-[60%] md:w-full text-[#FCE2B0] text-center">
          The number one website maker for the culturally relevant
        </p>
      </div>
      <div
        className="h-[15rem] flex justify-center items-center relative px-8 overflow-hidden"
        style={{
          backgroundImage: `url('/images/golden-quotes.png')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Semi-transparent white overlay to lighten the background
        <div className="absolute inset-0 bg-white opacity-10"></div> */}
      </div>
    </footer>
  );
};

export default Footer;
